import { MouseEvent, useState } from 'react';
import { ListSubheader, Menu, MenuItem, TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ArrowDropDownCircleOutlinedIcon from '@mui/icons-material/ArrowDropDownCircleOutlined';
import TagIcon from '@mui/icons-material/Tag';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { SvgIconComponent } from '@mui/icons-material';
import { CourseMappingCellType } from '../../interfaces/CourseMappingInterface';
import { CourseMappingFilterField } from './courseMappingFilterFields';

import './CourseMappingAddFilter.css';

const FIELD_TYPE_ICON: Record<CourseMappingCellType, SvgIconComponent> = {
  locked: LockOutlinedIcon,
  dropdown: ArrowDropDownCircleOutlinedIcon,
  editable: TagIcon,
  checkbox: CheckBoxOutlinedIcon,
};

interface CourseMappingAddFilterProps {
  availableFields: CourseMappingFilterField[];
  onSelect: (fieldKey: string) => void;
}

const CourseMappingAddFilter = ({ availableFields, onSelect }: CourseMappingAddFilterProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [query, setQuery] = useState('');
  const isOpen = Boolean(anchorEl);

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setQuery('');
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (fieldKey: string) => {
    onSelect(fieldKey);
    handleClose();
  };

  const filteredFields = availableFields.filter((field) =>
    field.label.toLowerCase().includes(query.trim().toLowerCase())
  );

  return (
    <>
      <button
        type="button"
        className="course-mapping-add-filter"
        onClick={handleOpen}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        disabled={availableFields.length === 0}
      >
        <AddIcon className="course-mapping-add-filter-icon" aria-hidden="true" />
        <span className="course-mapping-add-filter-label">Add filter</span>
      </button>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        autoFocus={false}
        PaperProps={{ className: 'course-mapping-add-filter-menu-paper' }}
      >
        <ListSubheader className="course-mapping-add-filter-search" onKeyDown={(event) => event.stopPropagation()}>
          <TextField
            size="small"
            fullWidth
            autoFocus
            placeholder="Filter by…"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
          />
        </ListSubheader>
        {filteredFields.map((field) => {
          const Icon = FIELD_TYPE_ICON[field.cellType];

          return (
            <MenuItem
              key={field.key}
              className="course-mapping-add-filter-item"
              onClick={() => handleSelect(field.key)}
            >
              <Icon className="course-mapping-add-filter-item-icon" fontSize="small" />
              <span>{field.label}</span>
            </MenuItem>
          );
        })}
        {filteredFields.length === 0 ? <li className="course-mapping-add-filter-empty">No matching fields</li> : null}
      </Menu>
    </>
  );
};

export default CourseMappingAddFilter;
